var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"auth bg-info"},[_c('el-card',{staticClass:"content-card"},[_c('div',{staticClass:"pr-30"},[_vm._v("\n      您没有使用该功能的权限，请联系管理员\n    ")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }